<template>
  <header class="header-content">
    <div class="flex items-center justify-between header-bg" style="width: 100%;padding: 0 80px;height: inherit;background: #FFFFFF">
      <div class="flex items-center">
        <div class="logo-container">
          <p class="logo-view flex items-center justify-center" @click="goHome">
            <img :src="require('@/assets/images/logo_copy.png')" alt="" />
          </p>
        </div>
        <el-menu
          :default-active="activeRoute"
          background-color="transparent"
          mode="horizontal"
          class="flex el-menu-horizontal"
          style="padding-left: 70px"
        >
          <div v-for="menu in menuList" :key="menu.name">
            <el-menu-item
              @click="clickMenuList(menu)"
              v-if="!menu.children"
              :index="menu.name"
            >
              <span slot="title">{{ menu.label }}</span>
            </el-menu-item>

            <el-submenu :index="menu.name" popper-class="submenu-popper" v-else>
              <template slot="title">
                <!-- <i :class="'el-icon-' + menu.icon"></i>-->
                <span slot="title">{{ menu.label }}</span>
              </template>
              <div v-for="subItem in menu.children" :key="subItem.name">
                <el-menu-item @click="clickMenuList(subItem)" :index="subItem.name">
                  <!-- <i :class="'el-icon-' + subItem.icon"></i>-->
                  <span slot="title">{{ subItem.label }}</span>
                </el-menu-item>
              </div>
            </el-submenu>
          </div>
        </el-menu>
      </div>
      <div class="flex items-center">
        <div class="file-manage" @click="$router.push({name: 'fileManagementGuoJiao'})">
          <el-badge :is-dot="isRead" class="badge-dot">
            <div class="flex items-center">
              <i class="el-icon-folder"></i>
              <span class="no-wrap">文件管理</span>
            </div>
          </el-badge>
        </div>

        <el-avatar size="small" :src="circleUrl" v-if="false"></el-avatar>

        <el-dropdown @command="clickMenu" trigger="hover" v-if="false">
          <span class="user-name no-wrap">{{ userName || 'test Name' }}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in menu"
              :key="item.path"
              :command="item"
            >{{ item.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
import { isReadApi } from '@/api/fileManagement';

export default {
  name: 'CommonHeader',
  data() {
    return {
      circleUrl:
        'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',

      userName: '', // 用户名
      // 用户菜单
      menu: [
        {
          path: '/login',
          name: 'Login',
          label: '退出登录',
        },
      ],
      menuList: [
        {
          path: '/resultsAnalysisGuoJiao',
          name: 'resultsAnalysisGuoJiao',
          label: '成果分析',
        },
        {
          path: '/requirementAnalysisGuoJiao',
          name: 'requirementAnalysisGuoJiao',
          label: '需求分析',
        },
        {
          path: '/scholarSearchGuoJiao',
          name: 'scholarSearchGuoJiao',
          label: '专家查询',
        },
        {
          path: '/technicalQAGuoJiao',
          name: 'technicalQAGuoJiao',
          label: '技术问答',
        },
        {
          path: '/historicRecordsGuoJiao',
          name: 'historicRecordsGuoJiao',
          label: '历史记录',
        },
        /*{
          path: '/researchToolkit',
          name: 'researchToolkit',
          label: '科研工具',
          children: [
            {
              path: '/researchToolkit/abstract',
              name: 'abstract',
              label: '生成摘要',
            },
            {
              path: '/researchToolkit/chinese',
              name: 'chinese',
              label: '中文润色',
            },
          ],
        },*/
      ],
      activeRoute: '',
      isRead: false,
    };
  },
  created() {
    this.userName = this.$store.state.userName || localStorage.getItem('at_userName');
    this.activeRoute = this.$route.query.active || this.$route.name;

    this.getIsRead();

    if (this.$route.name === 'resultsDetailsGuoJiao') {
      this.activeRoute = 'resultsAnalysisGuoJiao';
    }
    if (this.$route.name === 'requirementDetailsGuoJiao') {
      this.activeRoute = 'requirementAnalysisGuoJiao';
    }
    if (this.$route.name === 'scholarSearchHistoryGuoJiao') {
      this.activeRoute = 'scholarSearchGuoJiao';
    }
    if (this.$route.name === 'technicalQAHistoryGuoJiao') {
      this.activeRoute = 'technicalQAGuoJiao';
    }
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'resultsAnalysisGuoJiao' })
    },
    clickMenuList(item) {
      this.$router.push({
        name: item.name,
      });
    },
    clickMenu(item) {
      if (item.name === 'Login') {
        this.$message({
          message: '成功退出登录',
          type: 'success',
        });
        this.$store.commit('logout');
        this.$router.push({ name: 'login' });
      }
    },
    getIsRead() {
      isReadApi().then((res) => {
        this.isRead = res.data;
      })
    },
  },
  watch: {
    $route: {
      handler(to) {
        this.userName = this.$store.state.userName || localStorage.getItem('at_userName');
        this.activeRoute = to.query.active || to.name;

        if (to.name === 'resultsDetailsGuoJiao') {
          this.activeRoute = 'resultsAnalysisGuoJiao';
        }
        if (to.name === 'requirementDetailsGuoJiao') {
          this.activeRoute = 'requirementAnalysisGuoJiao';
        }
        if (to.name === 'scholarSearchHistoryGuoJiao') {
          this.activeRoute = 'scholarSearchGuoJiao';
        }
        if (to.name === 'technicalQAHistoryGuoJiao') {
          this.activeRoute = 'technicalQAGuoJiao';
        }
      },
      deep: true,
      immediate: true,
    }
  },
};
</script>

<style scoped lang="less">
.header-content {
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: url("~@/assets/images/bg.png");
  background-size: 100% auto;
  background-position: 0 0;
  background-repeat: no-repeat;

  .logo-container {
    display: flex;
    align-items: center;

    .logo-view {
      flex-shrink: 0;
      width: 300px;
      height: 40px;
      user-select: none;
      img {
        flex-shrink: 0;
        width: 293px;
        height: 33px;
        vertical-align: center;
      }
    }

    span {
      padding-left: 10px;
      font-weight: bold;
      font-size: 23px;
      color: #333;
      //font-style: italic;
    }
  }

  .user-name {
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;
    color: #333333;
  }

  .el-menu {
    //height: 100%;
    border: none;
    text-align: left;

    /deep/ .el-menu-item,
    /deep/ .el-submenu__title {
      background-color: transparent !important;
      display: block;
      font-size: 18px !important;
      text-align: left !important;
      margin: 0;
      color: #666666;
      padding: 0 20px;
      border-radius: 6px !important;
      height: 40px !important;
      line-height: 40px !important;
      //padding-left: 12px !important;
      letter-spacing: 0.5px;

      span {
        font-size: 18px !important;
      }
    }

    /deep/ .el-menu-item.is-active {
      //background-color: #0a74e0 !important;
      font-weight: 700 !important;
      color: #333333;
    }

    /deep/ .el-submenu {
      margin: 0 auto;
      .el-menu-item {
        padding-left: 20px !important;
      }
      ///deep/ .el-submenu__title {
      //  width: 100% !important;
      //}
      .el-submenu__icon-arrow {
        right: 0;
        font-size: 15px;
        font-weight: bold;
        color: #666666;
      }
    }
    /deep/.el-submenu.is-active {
      .el-submenu__title {
        color: #ffffff;
      }
      .el-submenu__icon-arrow {
        color: #ffffff;
      }
    }

    /deep/ .el-icon-star-on {
      font-size: 22px !important;
    }
  }

  .el-menu-horizontal {
    &:not(.el-menu--collapse) {
      //width: 200px;
    }

    /deep/ .el-menu-item {
      user-select: none !important;
    }

    /deep/ .el-submenu__icon-arrow.el-icon-arrow-right:before {
      content: '' !important;
    }
  }
}

.file-manage {
  color: #333333;
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-right: 20px;
  cursor: pointer;

  i{
    font-size: 18px;
    margin-right: 5px;
  }
}
</style>
<style lang="less">
.submenu-popper {
  .el-menu {
    .el-menu-item.is-active {
      color: #48adca;
      font-weight: bold;
    }
  }
}
</style>
